import {API} from "../types/API";

type CancelFn = () => void;
export const setupReconnect = () => {
    const expiresAt = localStorage.getItem('tokenExpiresAt') ?? null;
    const token = localStorage.getItem('userToken') ?? null;
    if (expiresAt && token) {
        const time = parseInt(expiresAt);
        if (time >  Date.now()) {
            scheduleAtMinusOneMinute(expiresAt, () => {
                API.reconnect();
            });
        }
    }
}

/**
 * Планирует callback за 1 минуту до указанного времени.
 * Возвращает функцию cancel(), чтобы отменить планирование.
 */
export function scheduleAtMinusOneMinute(
    datetimeYmdHis: string,
    callback: () => void
): CancelFn {
    const MAX_DELAY = 2_147_483_647; // ~24.8 дней — лимит для setTimeout
    const target = parseInt(datetimeYmdHis);
    const triggerAt = target - 60_000; // минус 1 минута
    let remaining = triggerAt - Date.now();

    let canceled = false;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const clear = () => {
        canceled = true;
        if (timer !== null) {
            clearTimeout(timer as unknown as number); // совместимо и с Node, и с браузером
            timer = null;
        }
    };

    // Если время уже прошло — выполнить как можно скорее
    if (remaining <= 0) {
        timer = setTimeout(() => {
            if (!canceled) callback();
        }, 0) as unknown as ReturnType<typeof setTimeout>;
        return clear;
    }

    const step = () => {
        if (canceled) return;
        if (remaining <= MAX_DELAY) {
            timer = setTimeout(() => {
                if (!canceled) callback();
            }, remaining) as unknown as ReturnType<typeof setTimeout>;
        } else {
            timer = setTimeout(() => {
                remaining -= MAX_DELAY;
                step();
            }, MAX_DELAY) as unknown as ReturnType<typeof setTimeout>;
        }
    };

    step();
    return clear;
}
